import { BotRol } from "./BotRol"

export class BotUsuario{
    id: string;
    firstName: string;
    lastName: string;
    rol: BotRol;
    correo: string;
}